import ApprovedDocumentsActions from './ApprovedDocumentsActions';
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios"; 
import { LangContext } from "../LangContext.jsx"; 
class PreviewFile extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = { 
        };
    } 
    showPreview = () => { 
        $('#visor-modal').modal('show');
    }
    render() {
        const { lang } = this.context; 
        const doc = this.props.doc;
        const fileUrl = doc.person_document_statuses_id === 2 
            ? `/document_dossier/${doc.person_providers_id}/review_file/${doc.id}` 
            : `/document_dossier/${doc.person_providers_id}/show_file/${doc.id}`;
        return (
            <>  
            <a  target='_blank' href={fileUrl}  onClick={() => showFile()} className="text-primary"
                >
                <span className="flaticon2-file-2 mr-2"></span>Vista Previa  
            </a>
            <div class="modal fade" id="visor-modal" tabindex="-1" role="dialog" aria-labelledby="visor-modal-label" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header"> 
                            <h5 class="modal-title" id="visor-modal-label">Vista Previa del documento</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body"> 
                            <div id="document-container">
                                El modal de vista previa
                                <iframe id="document-iframe"  class="document-iframe"   frameborder="0" width="100%" height="600"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}
export default PreviewFile;

if (document.getElementById('PreviewFile')) {
    ReactDOM.render(<PreviewFile />, document.getElementById('PreviewFile'));
}
